import { render } from "./user_profile.vue?vue&type=template&id=5a656232"
import script from "./user_profile.js?vue&type=script&lang=js"
export * from "./user_profile.js?vue&type=script&lang=js"

import "./user_profile.vue?vue&type=style&index=0&id=5a656232&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__